import { Telescope } from "lucide-react"
import { Button } from "@/components/ui/button"

interface DeepDiveButtonProps {
  /** Triggers the on-demand deep-dive request. */
  onRequest: () => Promise<boolean> | void
  /** Whether the deep-dive request for this message is in flight (controlled by the context,
   * keyed by chat + message, so it survives the button unmounting). */
  loading?: boolean
}

/**
 * Shown beneath a finalized answer without a deep dive yet. Asks the assistant for a fuller,
 * detailed explanation — definitions + the rules/examples behind the answer, with reference
 * links — delivered as a second message (POC 84, Thread H).
 */
export function DeepDiveButton({ onRequest, loading = false }: DeepDiveButtonProps) {
  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      className="h-7 gap-1.5 text-xs"
      disabled={loading}
      aria-label="Get a detailed deep dive with definitions and reference links"
      title="Get a detailed deep dive with definitions and reference links"
      onClick={() => {
        void onRequest()
      }}
    >
      <Telescope className="h-3.5 w-3.5" />
      {loading ? "Preparing the deep dive…" : "Deep dive"}
    </Button>
  )
}
